module.exports = "/_next/static/images/bc25ba3cb60307457f712827a013f434-ticket-02-01.png.webp";